import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { Tag } from '@repo/shared'

async function fetchTags(): Promise<Tag[]> {
  const { data, error } = await supabase
    .from('tags')
    .select('*')
    .order('name')

  if (error) throw error
  return (data ?? []) as Tag[]
}

export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: fetchTags,
    staleTime: 1000 * 60 * 30, // 30 minutes - tags rarely change
  })
}
